export const Booksdatalist = [
    {
        id: "1",
        img: "/assets/images/book-1.png",
        discount: "yes",
        like: "yes"
    },
    {
        id: "2",
        img: "/assets/images/book-10.png",
        discount: "yes",
        like: "no"
    },
    {
        id: "3",
        img: "/assets/images/book-4.png",
        discount: "no",
        like: "yes"
    },
    {
        id: "4",
        img: "/assets/images/book-9.png",
        discount: "yes",
        like: "no"
    },
    {
        id: "5",
        img: "/assets/images/book-7.png",
        discount: "yes",
        like: "no"
    },
    {
        id: "6",
        img: "/assets/images/book-2.png",
        discount: "yes",
        like: "no"
    },
    {
        id: "7",
        img: "/assets/images/book-1.png",
        discount: "yes",
        like: "no"
    },
    {
        id: "8",
        img: "/assets/images/book-10.png",
        discount: "yes",
        like: "no"
    },
]